import { Record } from 'immutable';

export type ApiDonorReviewSummary = {
  id: number;
  donor_id: number;
  review_count: number;
  total_score: number;
  average_score: number;
  is_hidden: boolean;
};

const DonorReviewSummaryBase = Record({
  id: 0,
  donorId: 0,
  reviewCount: 0,
  totalScore: 0,
  averageScore: 0,
  isHidden: false,
});

export class DonorReviewSummary extends DonorReviewSummaryBase {
  constructor(apiDonorReviewSummary?: ApiDonorReviewSummary) {
    super({
      id: apiDonorReviewSummary?.id,
      donorId: apiDonorReviewSummary?.donor_id,
      reviewCount: apiDonorReviewSummary?.review_count,
      totalScore: apiDonorReviewSummary?.total_score,
      averageScore: apiDonorReviewSummary?.average_score,
      isHidden: apiDonorReviewSummary?.is_hidden,
    });
  }

  readonly stars: string = '★'.repeat(Math.round(this.averageScore)) + '☆'.repeat(5 - Math.round(this.averageScore));
}
